// test2818
(2818 && 0);
